import object from 'helpers/object'


export const initialState = {
  learnList: [],
  isFetching: true,
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setLearnList = (state, payload) => (
  object.setIn(state, [ 'learnList' ], payload)
)
